module.exports = __webpack_public_path__ + "img/auddio.af4a0c61.png";